export default "__VITE_ASSET__Bt8htRaB__"